import { FootnotesContext } from '@contexts/footnotes'
import { withDisplayName } from '@hocs/with-display-name'
import { SuperscriptUI } from '@ui/superscript'
import { graphql } from 'gatsby'
import React, { useContext, useEffect, useRef } from 'react'

const ContentfulFootnoteSup: Utils.EntryFC<
  Queries.ContentfulFootnoteSupFragment
> = ({ content, entryInspectorProps, fieldInspectorProps }) => {
  const { setFootnotes } = useContext(FootnotesContext)
  const ref = useRef<number>(1)

  useEffect(() => {
    setFootnotes((footnotes) => {
      const index = footnotes.findIndex(
        (aFootnote) => aFootnote.id === content.id
      )

      if (index === -1) {
        ref.current = footnotes.length + 1
        return [...footnotes, content]
      }

      ref.current = index + 1
      return footnotes
    })
  }, [])

  return (
    <SuperscriptUI
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'content',
      })}
      value={ref.current}
    />
  )
}

export const query = graphql`
  fragment ContentfulFootnoteSup on ContentfulFootnote {
    ...ContentfulEntry
    ...ContentfulFootnoteRichText
  }
`

export default withDisplayName(ContentfulFootnoteSup, 'ContentfulFootnoteSup')
